export default "__VITE_ASSET__SMu9MTuN__"